import axios from 'axios'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useToast from 'hooks/useToast'
import auth from 'utils/Auth'

export const useRequest = () => {
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState({})
	const { showToast } = useToast()
	
	const apiUrl = process.env.REACT_APP_API_ENDPOINT

	axios.defaults.baseURL = apiUrl
	axios.interceptors.response.use(
		(response) => {
			return response
		},
		(err) => {
			return Promise.reject({ ...err })
		}
	)

	axios.defaults.baseURL = apiUrl

	const request = useCallback(async (url, options = {}) => {
		setLoading(true)
		const lang = JSON.parse(localStorage.getItem('lang'))
		options.headers = {
			Authorization: `Bearer ${auth.isHaveToken()}`,
			'Content-Type': 'application/json',
			'X-Culture': lang ? lang : 'tr',
			// restaurantId: auth.getUserChoises()?.restaurantId,
			// deliveryType: auth.getUserChoises()?.deliveryType,
			// neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
			// regionId: auth.getUserChoises()?.regionId,
			...options.headers,
		}
		options.data = options.data ? options.data : { ...options.body }
		options.transformRequest = [
			(data) => {
				Object.keys(data).forEach((key) => {
					if (data[key] === null) {
						delete data[key]
					}
				})
				return data;
			}, ...axios.defaults.transformRequest
		]
		const response = await axios(url, options).catch(err => {
			if (err.response?.status === 401) {
				  auth.clearStorage()
				  window.location = "/"
				  //navigate('/')
			}
			else if (err.response?.status === 404) {
				//navigate('/blabal')
			}
			else if (err.response?.status === 500) {
				if (err?.response?.data?.metadata?.message) {
						showToast(err?.response?.data?.metadata?.message, 'error')
				}
				// else {
				// 	navigate('/hata/500')
				// }
			}
			else if (err.response?.status === 400) {
				setError(err?.response?.data?.metadata?.dataObject)
					showToast(err?.response?.data?.metadata?.message, 'error')
			}
			return err
		}).finally(() => setLoading(false))
		return response
	}, [])
	return [request, loading, error]
}
